/**
 * AGROMX Frontend - Versión y novedades por rol (C-337)
 */

import api from './api.js';

class NovedadesService {
  /** Versión vigente; pública (sirve también en el login). */
  async version() {
    const response = await fetch(`${api.getBaseUrl()}/novedades/version`);
    const json = await response.json();
    return json.data || { version: null };
  }

  async pendientes() {
    const response = await api.get('/novedades/pendientes');
    return response.data;
  }

  async marcarVistas(versiones) {
    const response = await api.post('/novedades/vistas', { versiones });
    return response.data;
  }

  async historial() {
    const response = await api.get('/novedades/historial');
    return response.data;
  }
}

export default new NovedadesService();
